import supabase from '../supabase/supabase';

class VendorCreditService {
  async getAccountId() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("Not authenticated");
    
    const { data, error } = await supabase
      .from('profiles_20240320')
      .select('account_id')
      .eq('id', user.id)
      .single();
      
    if (error) {
      console.warn("Could not fetch account_id.");
      return null;
    }
    return data?.account_id;
  }

  async getCredits() {
    const { data, error } = await supabase
      .schema('accounting')
      .from('vendor_credits_1786044000000')
      .select(`
        *,
        vendor:vendor_id ( name )
      `)
      .order('issue_date', { ascending: false });
      
    if (error) throw error;
    return data || [];
  }

  async createCredit(creditData) {
    const accountId = await this.getAccountId();
    if (!accountId) throw new Error("Account ID required.");

    const { data, error } = await supabase
      .schema('accounting')
      .from('vendor_credits_1786044000000')
      .insert([{ 
        account_id: accountId, 
        vendor_id: creditData.vendor_id,
        credit_number: creditData.credit_number,
        issue_date: creditData.issue_date,
        total_amount: creditData.total_amount,
        balance: creditData.total_amount, // Initially, balance equals total
        reason: creditData.reason,
        notes: creditData.notes,
        status: 'AVAILABLE'
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  async updateCredit(id, creditData) {
    const { data, error } = await supabase
      .schema('accounting')
      .from('vendor_credits_1786044000000')
      .update({
        vendor_id: creditData.vendor_id,
        credit_number: creditData.credit_number,
        issue_date: creditData.issue_date,
        total_amount: creditData.total_amount,
        reason: creditData.reason,
        notes: creditData.notes,
        updated_at: new Date().toISOString()
        // Note: We don't blindly update balance/status here to avoid messing up application logic
      })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  async deleteCredit(id) {
    const { error } = await supabase
      .schema('accounting')
      .from('vendor_credits_1786044000000')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  }
}

export const vendorCreditService = new VendorCreditService();